import React, { useCallback } from 'react';
import styles from '../../../../styles/sass/components/YourNextTask.module.scss';
import { Button } from '@material-ui/core';
import { Circle, CaretRight, CheckCircle } from 'phosphor-react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchShowings } from '../../../../actions/showing';
import { fetchOffers } from '../../../../actions/offer';

interface Props {
  router: any;
}

const YourNextTask = ({ router }: Props) => {
  const dispatch = useDispatch();

  const {
    feedSearch,
    firstOfferSubmitted,
    firstShowingScheduled,
    token,
  } = useSelector((state: any) => {
    return {
      token: state.auth.token,
      feedSearch: state.feed.feedSearch,
      firstOfferSubmitted: state.dashboard.firstOfferSubmitted,
      firstShowingScheduled: state.dashboard.firstShowingScheduled,
    };
  });

  React.useEffect(() => {
    if (!firstShowingScheduled) {
      // Check if user has any existing showings, and toggle the task
      dispatch(fetchShowings(token));
    }
    if (!firstOfferSubmitted) {
      // Check if user has any existing offer, and toggle the task
      dispatch(fetchOffers(token));
    }
  }, []);

  const navigateToSearch = useCallback(() => {
    router.push({
      pathname: '/search',
      query: {
        location: feedSearch.location,
        filters: JSON.stringify(feedSearch),
      },
    });
  }, [feedSearch]);

  const renderNotStarted = () => {
    return (
      <div className={styles.container}>
        <div className={styles.photoContainer}>
          <button className={styles.photo} />
        </div>
        <div>
          <div className={styles.headingText}>{`Your Next Task`}</div>
          <div className={styles.itemContainer}>
            <div className={styles.item}>
              <div>
                <Circle size={32} color="#737373" weight="duotone" />
              </div>
              <div className={styles.itemText}>
                <div className={styles.itemMainText}>{`Schedule a tour`}</div>
                <div
                  className={styles.itemSubText}
                >{`Stay ahead of the competition by scheduling a showing`}</div>
              </div>
              <div className={styles.startTaskSection}>
                <Button
                  className={styles.taskButton}
                  onClick={navigateToSearch}
                >
                  {`Start Task `}
                  <CaretRight
                    size={32}
                    color="#443461"
                    weight="regular"
                    style={{ margin: 'auto' }}
                  />
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderOneCompleted = () => {
    const completedTask = firstOfferSubmitted
      ? {
          tasktitle: `Submit an offer`,
          taskInfo: `How exciting! Now it’s time to wait and see if your offer will be accepted. Our team will contact you when we have an update`,
        }
      : {
          tasktitle: `Schedule a tour`,
          taskInfo: `Stay ahead of the competition by scheduling a showing`,
        };
    const inCompleteTask = !firstOfferSubmitted
      ? {
          tasktitle: `Submit an offer`,
          taskInfo: `How exciting! Now it’s time to wait and see if your offer will be accepted. Our team will contact you when we have an update`,
        }
      : {
          tasktitle: `Schedule a tour`,
          taskInfo: `Stay ahead of the competition by scheduling a showing`,
        };
    return (
      <div>
        <div className={styles.container}>
          <div className={styles.photoContainer}>
            <button className={styles.photo} />
          </div>
          <div>
            <div
              className={styles.headingText}
            >{`Congrats! You’ve finished a task.`}</div>
            <div className={styles.itemContainer}>
              <div className={styles.item}>
                <div>
                  <CheckCircle size={32} color="#195A50" weight="fill" />
                </div>
                <div className={styles.itemText}>
                  <div className={styles.itemMainText}>
                    {completedTask.tasktitle}
                  </div>
                  <div className={styles.itemSubText}>
                    {completedTask.taskInfo}
                  </div>
                </div>
                <button className={styles.medalButtonComplete}>
                  Completed
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.container} style={{ marginTop: 20 }}>
          <div className={styles.photoContainer}>
            <button className={styles.photo} />
          </div>
          <div>
            <div className={styles.headingText}>{`Your Next Task`}</div>
            <div className={styles.itemContainer}>
              <div className={styles.item}>
                <div>
                  <Circle size={32} color="#737373" weight="duotone" />
                </div>
                <div className={styles.itemText}>
                  <div className={styles.itemMainText}>
                    {inCompleteTask.tasktitle}
                  </div>
                  <div className={styles.itemSubText}>
                    {inCompleteTask.taskInfo}
                  </div>
                </div>
                <div className={styles.startTaskSection}>
                  <Button
                    className={styles.taskButton}
                    onClick={navigateToSearch}
                  >
                    {`Start Task `}
                    <CaretRight
                      size={32}
                      color="#443461"
                      weight="regular"
                      style={{ margin: 'auto' }}
                    />
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderAllCompleted = () => {
    return (
      <div className={styles.container}>
        <div className={styles.photoContainer}>
          <button className={styles.smileyPhoto} />
        </div>
        <div>
          <div
            className={styles.headingText}
          >{`Congrats! You've sumbitted an offer`}</div>
          <div className={styles.headingSubText}>
            {`How exciting! Now it’s time to wait and see if your offer will be accepted. Our team will contact you when we have an update`}
          </div>
        </div>
      </div>
    );
  };

  // If not started with any task, then renderNotStarted() is executed
  return !firstOfferSubmitted && !firstShowingScheduled
    ? renderNotStarted()
    : firstOfferSubmitted && firstShowingScheduled
    ? renderAllCompleted()
    : renderOneCompleted();
};

export default YourNextTask;
